var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Base } from "../base";
var Icon = /** @class */ (function (_super) {
    __extends(Icon, _super);
    function Icon(id, source, width, height, color, paddingTop, onClickAction, setPadding, ariaLabel) {
        if (setPadding === void 0) { setPadding = true; }
        if (ariaLabel === void 0) { ariaLabel = null; }
        var _this = _super.call(this) || this;
        _this.enable = function () {
            _this.self.removeAttribute('disabled');
            _this.self.style.cursor = 'pointer';
            if (_this._isInteractive) {
                _this.self.tabIndex = 0;
            }
        };
        _this.disable = function () {
            _this.self.setAttribute('disabled', 'true');
            _this.self.style.cursor = '';
            if (_this._isInteractive) {
                _this.self.tabIndex = -1;
            }
        };
        _this._isInteractive = onClickAction !== null && onClickAction !== undefined;
        var icon = document.createElement('img');
        icon.id = id;
        icon.src = source;
        icon.style.width = width;
        icon.style.height = height;
        icon.style.cursor = 'pointer';
        icon.style.float = 'right';
        icon.style.margin = 'auto';
        if (setPadding) {
            icon.style.padding = '4px';
        }
        if (color) {
            icon.style.color = color;
        }
        if (paddingTop) {
            icon.style.paddingTop = paddingTop;
        }
        if (_this._isInteractive) {
            icon.setAttribute('role', 'button');
            if (ariaLabel) {
                icon.setAttribute('aria-label', ariaLabel);
            }
            icon.addEventListener('keydown', function (event) {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    icon.click();
                }
            });
        }
        icon.onclick = onClickAction;
        _this.self = icon;
        if (_this._isInteractive) {
            _this.enable();
        }
        return _this;
    }
    return Icon;
}(Base));
export { Icon };
